export default __webpack_public_path__ + "static/media/transaction-sum.c42850ec.svg";